!(function (t) {
    var e = {};
    function i(n) {
        if (e[n]) return e[n].exports;
        var r = (e[n] = { i: n, l: !1, exports: {} });
        return t[n].call(r.exports, r, r.exports, i), (r.l = !0), r.exports;
    }
    (i.m = t),
        (i.c = e),
        (i.d = function (t, e, n) {
            i.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n });
        }),
        (i.r = function (t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
        }),
        (i.t = function (t, e) {
            if ((1 & e && (t = i(t)), 8 & e)) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var n = Object.create(null);
            if ((i.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t))
                for (var r in t)
                    i.d(
                        n,
                        r,
                        function (e) {
                            return t[e];
                        }.bind(null, r)
                    );
            return n;
        }),
        (i.n = function (t) {
            var e =
                t && t.__esModule
                    ? function () {
                          return t.default;
                      }
                    : function () {
                          return t;
                      };
            return i.d(e, "a", e), e;
        }),
        (i.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (i.p = ""),
        i((i.s = 56));
})({
    0: function (t, e) {
        t.exports = function (t, e, i) {
            return e in t ? Object.defineProperty(t, e, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = i), t;
        };
    },
    10: function (t, e, i) {
        "use strict";
        i.r(e);
        var n = i(2),
            r = i.n(n),
            s = i(3),
            o = i.n(s),
            l = i(0),
            a = i.n(l);
        function u(t, e) {
            var i;
            if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
                if (
                    Array.isArray(t) ||
                    (i = (function (t, e) {
                        if (!t) return;
                        if ("string" == typeof t) return d(t, e);
                        var i = Object.prototype.toString.call(t).slice(8, -1);
                        "Object" === i && t.constructor && (i = t.constructor.name);
                        if ("Map" === i || "Set" === i) return Array.from(t);
                        if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return d(t, e);
                    })(t)) ||
                    (e && t && "number" == typeof t.length)
                ) {
                    i && (t = i);
                    var n = 0,
                        r = function () {};
                    return {
                        s: r,
                        n: function () {
                            return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
                        },
                        e: function (t) {
                            throw t;
                        },
                        f: r,
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var s,
                o = !0,
                l = !1;
            return {
                s: function () {
                    i = t[Symbol.iterator]();
                },
                n: function () {
                    var t = i.next();
                    return (o = t.done), t;
                },
                e: function (t) {
                    (l = !0), (s = t);
                },
                f: function () {
                    try {
                        o || null == i.return || i.return();
                    } finally {
                        if (l) throw s;
                    }
                },
            };
        }
        function d(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
            return n;
        }
        var h = (function () {
                function t(e) {
                    var i = e.elementSelector,
                        n = void 0 === i ? "" : i,
                        s = e.pixelChange,
                        o = void 0 === s ? 1 : s,
                        l = e.intervalSpeedMS,
                        d = void 0 === l ? 20 : l,
                        h = e.timeToTransitionMS,
                        f = void 0 === h ? 1e3 : h;
                    if ((r()(this, t), a()(this, "_sliderEls", void 0), ("string" == typeof n || n instanceof String) && "" !== n)) {
                        if (((this.sliderEls = document.querySelectorAll(n)), !this.sliderEls)) return;
                        var v,
                            p = u(this.sliderEls);
                        try {
                            for (p.s(); !(v = p.n()).done; ) {
                                var S = v.value;
                                new c({ element: S, pixelChange: o, intervalSpeedMS: d, timeToTransitionMS: f });
                            }
                        } catch (t) {
                            p.e(t);
                        } finally {
                            p.f();
                        }
                    }
                }
                return (
                    o()(t, [
                        {
                            key: "sliderEls",
                            set: function (t) {
                                this._sliderEls = t;
                            },
                            get: function () {
                                return this._sliderEls;
                            },
                        },
                    ]),
                    t
                );
            })(),
            c = (function () {
                function t(e) {
                    var i = e.element,
                        n = e.pixelChange,
                        s = void 0 === n ? 1 : n,
                        o = e.intervalSpeedMS,
                        l = void 0 === o ? 20 : o,
                        u = e.timeToTransitionMS,
                        d = void 0 === u ? 1e3 : u;
                    r()(this, t),
                        a()(this, "_slide1", void 0),
                        a()(this, "_slide2", void 0),
                        a()(this, "_pixelChange", void 0),
                        a()(this, "_intervalSpeedMS", void 0),
                        a()(this, "_timeToTransitionMS", void 0),
                        a()(this, "_currentPositionSlide1", void 0),
                        a()(this, "_currentPositionSlide2", void 0),
                        a()(this, "_slideWidth", void 0),
                        (this.slide1 = i),
                        this.slide1 &&
                            ((this.slide2 = this.slide1.cloneNode(!0)),
                            this.slide1.parentElement.appendChild(this.slide2),
                            (this.pixelChange = s),
                            (this.intervalSpeedMS = l),
                            (this.timeToTransitionMS = d),
                            (this.slideWidth = this.slide1.offsetWidth),
                            (this.currentPositionSlide1 = 0),
                            (this.currentPositionSlide2 = this.slideWidth),
                            this.bindEvents(),
                            this.setTransform(this.pixelChange),
                            this.scroll(),
                            console.log(this.slideWidth));
                }
                return (
                    o()(t, [
                        {
                            key: "setTransform",
							value: function (t) {
								this.currentPositionSlide1 -= t;
								this.currentPositionSlide2 -= t;

								// Logic for forward scrolling
								if (this.pixelChange > 0) {
									if (this.currentPositionSlide1 <= -this.slideWidth) {
										this.currentPositionSlide1 = this.slideWidth;
										this.currentPositionSlide2 = 0;
									}
									if (this.currentPositionSlide2 <= -this.slideWidth) {
										this.currentPositionSlide1 = 0;
										this.currentPositionSlide2 = this.slideWidth;
									}
								}
								// Logic for reverse scrolling
								else {
									if (this.currentPositionSlide1 >= this.slideWidth) {
										this.currentPositionSlide1 = -this.slideWidth;
										this.currentPositionSlide2 = 0;
									}
									if (this.currentPositionSlide2 >= this.slideWidth) {
										this.currentPositionSlide1 = 0;
										this.currentPositionSlide2 = -this.slideWidth;
									}
								}

								var e = "translateX( " + this.currentPositionSlide1 + "px)",
									i = "translateX( " + this.currentPositionSlide2 + "px)";
								this.slide1.style.transform = e;
								this.slide1.style.webkitTransform = e;
								this.slide1.style.msTransform = e;
								this.slide2.style.transform = i;
								this.slide2.style.webkitTransform = i;
								this.slide2.style.msTransform = i;
							},
                        },
                        {
                            key: "bindEvents",
                            value: function () {
                                var t = this;
                                this.slide1.addEventListener(
                                    "mouseenter",
                                    function () {
                                        t.slowStop();
                                    },
                                    !1
                                ),
                                    this.slide1.addEventListener(
                                        "mouseleave",
                                        function () {
                                            t.slowStart();
                                        },
                                        !1
                                    ),
                                    this.slide2.addEventListener(
                                        "mouseenter",
                                        function () {
                                            t.slowStop();
                                        },
                                        !1
                                    ),
                                    this.slide2.addEventListener(
                                        "mouseleave",
                                        function () {
                                            t.slowStart();
                                        },
                                        !1
                                    );
                            },
                        },
                        {
                            key: "scroll",
                            value: function () {
                                var t = this;
                                this.stop(),
                                    (this.intervalID = setInterval(function () {
                                        t.setTransform(t.pixelChange);
                                    }, this.intervalSpeedMS));
                            },
                        },
                        {
                            key: "stop",
                            value: function () {
                                clearInterval(this.intervalID);
                            },
                        },
                        {
                            key: "slowStop",
                            value: function () {
                                var t = this;
                                this.stop();
                                var e = this.pixelChange;
                                this.intervalID = setInterval(function () {
                                    (e -= t.speedFactor()), t.setTransform(e), e <= 0 && t.stop();
                                }, this.intervalSpeedMS);
                            },
                        },
                        {
                            key: "slowStart",
                            value: function () {
                                var t = this;
                                this.stop();
                                var e = 0;
                                this.intervalID = setInterval(function () {
                                    (e += t.speedFactor()), t.setTransform(e), e >= t.pixelChange && t.scroll();
                                }, this.intervalSpeedMS);
                            },
                        },
                        {
                            key: "speedFactor",
                            value: function () {
                                return this.pixelChange / (this.timeToTransitionMS / this.intervalSpeedMS);
                            },
                        },
                        {
                            key: "slide1",
                            set: function (t) {
                                this._slide1 = t;
                            },
                            get: function () {
                                return this._slide1;
                            },
                        },
                        {
                            key: "slide2",
                            set: function (t) {
                                this._slide2 = t;
                            },
                            get: function () {
                                return this._slide2;
                            },
                        },
                        {
                            key: "pixelChange",
                            set: function (t) {
                                this._pixelChange = t;
                            },
                            get: function () {
                                return this._pixelChange;
                            },
                        },
                        {
                            key: "intervalSpeedMS",
                            set: function (t) {
                                this._intervalSpeedMS = t;
                            },
                            get: function () {
                                return this._intervalSpeedMS;
                            },
                        },
                        {
                            key: "timeToTransitionMS",
                            set: function (t) {
                                this._timeToTransitionMS = t;
                            },
                            get: function () {
                                return this._timeToTransitionMS;
                            },
                        },
                        {
                            key: "currentPositionSlide1",
                            set: function (t) {
                                this._currentPositionSlide1 = t;
                            },
                            get: function () {
                                return this._currentPositionSlide1;
                            },
                        },
                        {
                            key: "currentPositionSlide2",
                            set: function (t) {
                                this._currentPositionSlide2 = t;
                            },
                            get: function () {
                                return this._currentPositionSlide2;
                            },
                        },
                        {
                            key: "slideWidth",
                            set: function (t) {
                                this._slideWidth = t;
                            },
                            get: function () {
                                return this._slideWidth;
                            },
                        },
                        {
                            key: "intervalID",
                            set: function (t) {
                                this._intervalID = t;
                            },
                            get: function () {
                                return this._intervalID;
                            },
                        },
                    ]),
                    t
                );
            })();
        window.sliderTracks = function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ".related-posts-carousel.variable-width",
                e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
                i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 20,
                n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1e3;
            new h({ elementSelector: t, pixelChange: e, intervalSpeedMS: i, timeToTransitionMS: n });
        };
    },
    2: function (t, e) {
        t.exports = function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        };
    },
    3: function (t, e) {
        function i(t, e) {
            for (var i = 0; i < e.length; i++) {
                var n = e[i];
                (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            }
        }
        t.exports = function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
        };
    },
    56: function (t, e, i) {
        t.exports = i(10);
    },
});

(function () {
    sliderTracks(".ticker .track-slider.first-row", 1, 15, 1000);
})();

(function () {
    sliderTracks(".ticker .track-slider.second-row", -1, 15, 1000);
})();
